import { fetchAuthContext, getCachedAuthContext } from '../api/auth.js';

/** 登录成功后根据租户绑定状态决定落点 */
export async function resolvePostLoginPath() {
  try {
    const ctx = await fetchAuthContext({ includeStats: false, backgroundStats: false });
    if (ctx?.needsTenantJoin) {
      return '/onboarding/tenant';
    }
  } catch (e) {
    console.warn('[postLoginNavigation] auth context 拉取失败', e);
    const cached = getCachedAuthContext();
    if (cached && cached.needsTenantJoin === false) {
      return '/welcome';
    }
    return '/onboarding/tenant';
  }
  return '/welcome';
}

export async function navigateAfterLogin(navigate) {
  const path = await resolvePostLoginPath();
  navigate(path, { replace: true });
}
